<template>
  <div class="register__description__header">
    <h3 class="register__description__title">Don&apos;t have an account?</h3>
    <button type="button" class="login__signup-button" @click="handleSignUp">
      Sign Up
    </button>

    <div class="leverage-container">
      <p>
        Leverage the power of MeTime for your aesthetic medical or wellness
        business - appear in the app and start matching with potential patients.
      </p>

      <BookADemo @click="$emit('openDemo')" class="book-button" />
    </div>
  </div>
</template>

<script setup>
import BookADemo from "@/components/BookADemo";
import { useRouter } from "vue-router";
import { ROUTES } from "@/const";

const router = useRouter();

defineEmits(["openDemo"]);

const handleSignUp = () => {
  const SIGN_UP_ROUTE = ROUTES.get("SIGN_UP");
  router.push(SIGN_UP_ROUTE.path);
};
</script>

<style scoped lang="scss">
.register__description__title {
  @media only screen and (min-width: 1200px) and (max-width: 1399.98px) {
    font-size: 28px;
  }

  @media only screen and (min-width: 1024px) and (max-width: 1199.98px) {
    font-size: 24px;
  }

  @media only screen and (max-width: 767.98px) {
    font-size: 28px;
    margin-bottom: 0;
  }

  @media only screen and (max-width: 480px) {
    font-size: 20px;
  }

  @media only screen and (max-width: 360px) {
    font-size: 18px;
  }

  @media only screen and (max-width: 330px) {
    font-size: 16px;
  }
}

.register__description__header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;

  h3 {
    margin-bottom: 0;
  }
}

.leverage-container {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.book-button {
  margin: 0 auto;

  @media only screen and (max-width: 767.98px) {
    width: 100%;
  }
}
</style>
